import React, { Component } from "react";
import { connect } from "react-redux";
import IlearnBanner from "views/ilearn/components/IlearnBanner";
import FooterSection from "views/home/components/FooterSection";
import IlearnCourses from "views/ilearn/components/IlearnCourses";
import "../css/Index.scss";
import { GetAllCourseAction } from "store/Ilearn";
class Ilearn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      courses: [],
    };
  }

  async componentDidMount() {
    try {
      let response = await this.props.getAllCourses();
      // console.log(response.data);
      if (response.Data) {
        this.setState({ courses: response.Data });
      }
    } catch (error) {}

    // this.props.getAllCourses().then((res) =>{
    //   this.setState({ courses: res.data.Data });
    // })
    // .catch((err)=>console.log(err))
  }
  render() {
    return (
      <div className="mt-80px  lg:pt-8 md:pt-8">
        <div className="mx-auto container mb-4 lg:block md:block hidden">
          <ul className="bradcrumb flex">
            <li className="bradcrumb-li fsize14">Home </li>&nbsp;/&nbsp;
            <li className="text-black fsize14 font-semibold">
              Business Loans Relationship Manager
            </li>
          </ul>
        </div>

        <div className="mx-auto container ">
          <div className="lg:px-0 md:px-0 px-5">
            {" "}
            <IlearnBanner courses={this.state.courses} />
          </div>
        </div>

        <div className="mx-auto container">
          <IlearnCourses courses={this.state.courses} />
        </div>

        <div className="mt-6 footer-css">
          <FooterSection courses={this.state.courses} />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    GETALLCOURSE: state.iLearn.course.ALLCOURSES,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllCourses: async () => await dispatch(GetAllCourseAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Ilearn);
// export default JobDetails;
